import { createI18n } from '@drama/i18n'
import { zh } from './zh.js'
import { en } from './en.js'
import { ja } from './ja.js'
import { es } from './es.js'
import { id } from './id.js'
import { pt } from './pt.js'

const localMessages = { zh, en, ja, es, id, pt }

/**
 * @param {{ locale?: string }} [opts]
 */
export function createStudioI18n(opts = {}) {
  const runtime = createI18n(opts)
  for (const [locale, messages] of Object.entries(localMessages)) {
    runtime.i18n.global.mergeLocaleMessage(locale, messages)
  }
  return runtime
}
